/* ════════════════════════════════════════════════════════════════════════════════════════════════════
   BKS · COUCHE HALLOWEEN 2026 — comportement (lot « halloween », 01/10/2026 ; v2 du soir)
   Chargé en `async` (05/10 ; `defer` avant, voir « démarrage ») par snippets/bks-halloween.liquid, qui pose AVANT lui `window.BKS_HW`
   ({ debut, fin, decalage, actif, popup, decor, config, gabarit, code, chrono }) et la classe `bks-hw` sur
   <html> si la date du visiteur est dans la fenêtre. Rien ici ne s'exécute hors de la fenêtre.

   CE QUE FAIT CE FICHIER
   1. les comptes à rebours ([data-bks-hw-chrono] [data-u]) — barre, pop-up, capture des fiches : UN seul
      minuteur pour tous ; à zéro, la couche s'éteint en direct (classes retirées, pop-up fermée, décor ôté,
      capture retirée) — c'est le contrôle JS de la date demandé contre le cache des pages ;
   2. le bouton « copier le code » ([data-bks-hw-copier]) partout ;
   3. le ciel de l'accueil et de la LP : lune, étoiles, chauves-souris, brume et (v2) la sorcière qui traverse
      la lune une fois — injectés DANS `.bksaa-hero` (gelé, jamais réécrit) en position absolue ;
   4. la pop-up Halloween — mêmes règles que la pop-up WELCOME10 qu'elle remplace en octobre (4,5 s après la
      décision de consentement, 7 j de silence si fermée), jamais par-dessus le consentement, un tiroir ouvert
      ou une saisie ; sur un CONFIGURATEUR, seulement après 4,5 s sans geste ; même branchement Klaviyo
      (company UV7NE3 ; liste U9RTDS « Halloween 2026 » depuis le 02/10 13 h, révision 2026-07-15, voir § 4) ;
   5. (v2) chapeaux de sorcière posés sur la 1re lettre des titres, balais croisés et citrouilles du bandeau
      des collections, scène de nuit de la 404, citrouille du panier vide.
   Tout élément de décor ajouté est `aria-hidden`, absolu, sans texte, et porte `data-bks-hw-retirer` : il
   disparaît à l'extinction. Aucun texte du site n'est modifié.
   Tour 1 de recette (01/10, 23 h) : bandeau des collections placé par MESURE (jamais sur la photo) ;
   citrouille du panier vide ancrée sur la carte visible ; chapeau à 6 px d'air de tout voisin (boîte
   calculée) ; chapeau du titre aussi sur les fiches de configurateur ; téléphone : croissant + sorcière
   dans la bande libre sous le chercheur du héros (accueil, LP). Portes : outils/0110v2/halloween/t1/.
   Reprise du 02/10 (rapport site/rapports/0210-halloween.md) : la pop-up lit ET pose les marques de la WELCOME10
   (inscrit 30 j, fermée 7 j) ; sur un configurateur elle s'ouvre 4,5 s après le dernier geste, sans délai
   « après consentement » en plus. Portes : outils/0210/halloween/.
   02/10, 11 h — EXIGENCE DE LUDO : LE CODE N'EST JAMAIS DONNÉ SANS E-MAIL. Il n'est écrit en clair NULLE PART dans
   ce que reçoit le navigateur (ni HTML, ni script en ligne, ni ce fichier : il y est CODÉ, voir `codeClair()`) ;
   il n'est reconstitué et écrit dans la page ([data-bks-hw-code]) que pour un visiteur qui a le DROIT de le voir :
     · inscrit par la capture (prénom, nom, e-mail, case de consentement → Klaviyo répond 202), sur ce navigateur ;
     · venu d'une PUBLICITÉ (BKS_HW.pub, décidé par le script en ligne du snippet avant le premier affichage).
   Les deux captures — celle de la barre / pop-up et celle des fiches — sont gérées ICI par délégation (un bloc de
   fiche re-rendu par Prestige au changement de variante perd ses scripts en ligne : la délégation, non).
   ⚠️ Codé n'est pas secret : un développeur qui lit ce fichier peut le reconstituer. La seule protection totale
   est un code UNIQUE par inscrit, envoyé par Klaviyo (lot « flux ») — voir le rapport.

   Mouvement : chaque animation est en CSS et coupée par prefers-reduced-motion (bks-halloween.css § 12).
   ════════════════════════════════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var C = window.BKS_HW;
  if (!C || !C.actif) return;
  var html = document.documentElement;

  function maintenant() { return Date.now() + (C.decalage || 0); }
  function enCours() { var n = maintenant(); return n >= C.debut && n <= C.fin; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function retirer(el) { if (el && el.parentNode) el.parentNode.removeChild(el); }

  /* ------------------------------------------------------------------ 1. extinction et minuteur */
  /* 05/10 au soir (vérificateur technique, tour 1) — EXTINCTION EN DIRECT SANS DÉCALAGE. Page ouverte au passage de minuit
     le 31/10 : la barre et la capture des fiches étaient retirées et tout le contenu remontait (layout-shift 0,0502 mesuré
     par le vérificateur, prise « veille-fiche », sur main#main) ; et bks-hw-g-*, bks-hw-pub, bks-hw-inscrit restaient sur
     <html>. Ce fichier ne peut s'éteindre qu'APRÈS que le script en ligne du snippet a déclaré l'offre active (sinon il
     s'arrête dès sa 1re ligne) : la barre et la capture ont donc pu être peintes. Désormais :
       · la barre et la capture restent À LEUR PLACE, invisibles et inertes (visibility:hidden, inert, aria-hidden), avec
         la boîte qu'elles avaient, jusqu'au prochain chargement — où la couche n'est plus rendue du tout (garde Liquid) ;
       · ce que les classes de la couche donnaient à des éléments du thème (hauteur mini du héros de l'accueil, marges de
         la 404) est figé à sa valeur avant de retirer les classes ;
       · TOUTES les classes bks-hw* quittent <html> ;
       · décors (absolus) et pop-up (fixe) retirés comme avant : ils ne poussent rien. */
  var eteinte = false, tic = null;
  function figer(el, props) {
    if (!el) return;
    var cs = getComputedStyle(el);
    for (var i = 0; i < props.length; i++) el.style.setProperty(props[i], cs.getPropertyValue(props[i]));
  }
  function masquer(el) {
    if (!el) return;
    el.style.setProperty('visibility', 'hidden');
    el.setAttribute('aria-hidden', 'true');
    el.setAttribute('inert', '');
  }
  function eteindre() {
    if (eteinte) return;
    eteinte = true;
    if (tic) { clearInterval(tic); tic = null; }
    try { if (C.arreterTic) C.arreterTic(true); } catch (e) {}
    /* les boîtes AVANT de retirer les classes (la barre et la capture n'ont la leur que sous html.bks-hw) */
    try {
      var bar = document.querySelectorAll('.bks-hw-barre');
      for (var b0 = 0; b0 < bar.length; b0++) { figer(bar[b0], ['display', 'height']); bar[b0].style.overflow = 'hidden'; masquer(bar[b0]); }
      var cap = document.querySelectorAll('[data-bks-cap]');
      for (var c0 = 0; c0 < cap.length; c0++) {
        figer(cap[c0].closest('.bks-rentree-place'), ['display']);
        figer(cap[c0], ['display']);
        masquer(cap[c0]);
        cap[c0].removeAttribute('data-bks-hw-retirer');   /* gardée en place, vide de sens, jusqu'au prochain chargement */
      }
      figer(document.querySelector('.bksaa-hero'), ['min-height']);
      figer(document.querySelector('.shopify-section--404 > .section-spacing'), ['padding-top']);
      figer(document.querySelector('.shopify-section--404 .bkspg'), ['margin-top']);
    } catch (e) {}
    var cl = [];
    for (var c1 = 0; c1 < html.classList.length; c1++) if (html.classList[c1].indexOf('bks-hw') === 0) cl.push(html.classList[c1]);
    for (c1 = 0; c1 < cl.length; c1++) html.classList.remove(cl[c1]);
    /* plus aucune ouverture possible : sonde arrêtée, ouverture programmée annulée, pop-up fermée PUIS ôtée */
    try { arreterSonde(); if (ouvertureId) { clearTimeout(ouvertureId); ouvertureId = null; } } catch (e) {}
    try { fermerPop(false); } catch (e) {}
    if (pop) { var p0 = pop; setTimeout(function () { retirer(p0); }, 400); }
    retirer(document.querySelector('.bks-hw-ciel'));
    var r = document.querySelectorAll('[data-bks-hw-retirer]');
    for (var i = 0; i < r.length; i++) retirer(r[i]);
    var t = document.querySelectorAll('.bks-hw-porte-chapeau, .bks-hw-porte-citrouille, .bks-hw-mm');
    for (var k = 0; k < t.length; k++) t[k].classList.remove('bks-hw-porte-chapeau', 'bks-hw-porte-citrouille', 'bks-hw-mm');
    try { if (megaRo) megaRo.disconnect(); } catch (e) {}
  }

  function majChronos() {
    var reste = C.fin - maintenant();
    if (reste <= 0) { eteindre(); return; }
    var s = Math.floor(reste / 1000);
    var v = { j: pad(Math.floor(s / 86400)), h: pad(Math.floor((s % 86400) / 3600)), m: pad(Math.floor((s % 3600) / 60)), s: pad(s % 60) };
    var els = document.querySelectorAll('[data-bks-hw-chrono] [data-u]');
    for (var i = 0; i < els.length; i++) {
      var t = v[els[i].getAttribute('data-u')];
      if (t && els[i].textContent !== t) els[i].textContent = t;
    }
  }

  /* ------------------------------------------------------------------ 2. le code, et qui a le droit de le voir */
  /* Le code de la campagne, CODÉ (octets à l'envers, mêlés d'une clé tournante). Ces deux lignes sont RÉÉCRITES par
     outils/0210/halloween/K3-coder.js, qui lit le code dans l'API Shopify (règle de prix de la campagne) : il n'est
     tapé nulle part. Porte K4-portes-code.js : le code en clair (et à l'envers) est introuvable dans les 4 fichiers. */
  var CQ = [106, 157, 140, 113, 128, 8, 227, 142, 120, 132, 23], CK = [95, 172, 194, 52, 197];
  function codeClair() {
    var s = '';
    for (var i = CQ.length - 1; i >= 0; i--) s += String.fromCharCode(CQ[i] ^ CK[i % CK.length]);
    return s;
  }
  var LS_OK = 'bks_hw15_ok';      /* inscrit (barre, pop-up ou fiche) : partagé par les deux captures */
  var C_INSCRIT = 'bks_hw_pop_s'; /* inscrit → plus de pop-up d'ici la fin */
  function lireCookie(n) { var m = document.cookie.match('(^|;)\\s*' + n + '\\s*=\\s*([^;]+)'); return m ? m.pop() : ''; }
  function lsLire(k) { try { return window.localStorage ? localStorage.getItem(k) : null; } catch (e) { return null; } }
  function lsPoser(k, v) { try { if (window.localStorage) localStorage.setItem(k, v); } catch (e) {} }
  function estInscrit() { return lsLire(LS_OK) === '1' || !!lireCookie(C_INSCRIT); }
  /* Lien /discount/<code> (02/10, tour 1) : Shopify pose le cookie discount_code, lisible ici. S'il porte LE code
     d'Halloween (lien du mail du flux, ou d'une pub), le visiteur l'a déjà : la barre peut le lui montrer. S'il porte un
     AUTRE code (lien d'un partenaire du lot affiliation, code d'un mail du cycle…), aucun droit : prénom, nom, e-mail comme
     tout le monde. Avant ce jour, n'importe quel cookie discount_code ouvrait le droit (vu au rejeu du vérificateur technique :
     un visiteur arrivé par le lien d'un partenaire voyait le code d'Halloween et pouvait remplacer, au paiement, le code du
     partenaire — qui perdait sa commission). */
  try {
    var dc = decodeURIComponent(lireCookie('discount_code') || '').replace(/\+/g, ' ').trim().toUpperCase();
    if (!C.pub && dc && dc === codeClair().toUpperCase()) {
      C.pub = true;
      html.classList.add('bks-hw-pub');
      try { sessionStorage.setItem('bks_hw_pub', '1'); } catch (x) {}
    }
  } catch (e) {}
  function aLeDroit() { return !!C.pub || estInscrit(); }
  /* écrit le code partout où la page lui a réservé une place — SEULEMENT pour qui a le droit de le voir */
  function montrerCodes() {
    if (!aLeDroit()) return;
    if (estInscrit()) html.classList.add('bks-hw-inscrit');
    var c = codeClair(), els = document.querySelectorAll('[data-bks-hw-code]');
    for (var i = 0; i < els.length; i++) if (els[i].textContent !== c) els[i].textContent = c;
  }

  /* ------------------------------------------------------------------ 2 bis. copier le code */
  function copierTexte(txt, fin) {
    function repli() {
      var ta = document.createElement('textarea');
      ta.value = txt; ta.setAttribute('readonly', '');
      ta.style.position = 'fixed'; ta.style.top = '-1000px'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      document.body.removeChild(ta);
      fin(ok);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(txt).then(function () { fin(true); }, repli);
    else repli();
  }
  document.addEventListener('click', function (e) {
    /* « Je reçois mon code » (barre) : ouvre la capture, partout — c'est un geste du visiteur, les règles de
       fréquence de la pop-up automatique (fermée il y a moins de 7 j…) ne s'y appliquent pas */
    var o = e.target && e.target.closest ? e.target.closest('[data-bks-hw-ouvrir]') : null;
    if (o) { e.preventDefault(); ouvrirCapture('barre', o); return; }
    var b = e.target && e.target.closest ? e.target.closest('[data-bks-hw-copier]') : null;
    if (!b) return;
    /* pas le droit (le bouton ne devrait pas être visible) : on n'écrit rien, on propose la capture */
    if (!aLeDroit()) { e.preventDefault(); ouvrirCapture('barre', b); return; }
    var code = codeClair();
    var lib = b.querySelector('[data-bks-hw-copier-txt]') || b;
    if (!b.hasAttribute('data-bks-hw-txt0') && !lib.hasAttribute('data-bks-hw-code')) b.setAttribute('data-bks-hw-txt0', lib.textContent);
    /* largeur figée le temps du retour : le libellé change, le bouton ne bouge pas (ni ses voisins) */
    b.style.minWidth = b.getBoundingClientRect().width + 'px';
    copierTexte(code, function (ok) {
      lib.textContent = ok ? 'Copié !' : code;
      b.classList.add('is-copie');
      var zone = b.closest('[role="dialog"], .bks-hw-barre, .bks-rentree');
      var annonce = zone ? zone.querySelector('[aria-live="polite"]') : null;
      if (annonce) annonce.textContent = ok ? 'Code ' + code + ' copié.' : 'Copie impossible : sélectionne le code ' + code + ' à la main.';
      setTimeout(function () {
        /* le libellé d'origine du billet de la barre est le code lui-même : on le réécrit depuis codeClair(), jamais
           depuis un attribut (le code ne doit pas traîner dans le DOM d'un visiteur qui n'a pas le droit) */
        lib.textContent = lib.hasAttribute('data-bks-hw-code') ? codeClair() : b.getAttribute('data-bks-hw-txt0');
        b.classList.remove('is-copie'); b.style.minWidth = '';
      }, 1900);
    });
  });

  /* ------------------------------------------------------------------ 3. le ciel de l'accueil (et de la LP) */
  function svgUse(id, vb, cls) { return '<svg' + (cls ? ' class="' + cls + '"' : '') + ' viewBox="' + vb + '" focusable="false"><use href="#' + id + '"/></svg>'; }
  function poserCiel() {
    if (!C.decor || !html.classList.contains('bks-hw-decor')) return;
    var hero = document.querySelector('.bksaa-hero');
    if (!hero || hero.querySelector('.bks-hw-ciel')) return;
    var vol = function (n) { return '<span class="bks-hw-vol bks-hw-vol--' + n + '">' + svgUse('bks-hw-s-cs', '0 0 64 26', 'bks-hw-cs') + '</span>'; };
    var ciel = document.createElement('div');
    ciel.className = 'bks-hw-ciel';
    ciel.setAttribute('aria-hidden', 'true');
    /* v2 : la sorcière est AVANT les chauves-souris dans le DOM (peinte dessous si leurs chemins se croisent) */
    ciel.innerHTML = '<span class="bks-hw-ciel__etoiles"></span><span class="bks-hw-ciel__lune"></span>' +
      '<span class="bks-hw-deco bks-hw-ciel__sorciere bks-hw-sorciere-nuit">' + svgUse('bks-hw-s-sorciere', '0 0 120 60') + '</span>' +
      vol(1) + vol(2) + '<span class="bks-hw-ciel__brume"></span>';
    calerCielTel(ciel, hero);   /* positions du téléphone posées AVANT l'ajout : rien ne bouge après le 1er rendu */
    hero.appendChild(ciel);
    calerCielTel(ciel, hero);
    guetterTraversee(ciel, hero);
  }
  /* Tour 1 (vérificateur) — TÉLÉPHONE : le premier écran n'avait AUCUN motif (rien sur la photo : c'est la
     selle). Il reste une bande sombre LIBRE sous le chercheur (68 px mesurés de 360 à 414 px de large, accueil
     et LP : rembourrage bas de `.bksaa-finder-w`). On y pose un croissant de 22 px juste à gauche de la bulle
     WhatsApp (jamais dessous) et la sorcière, en lilas, y file UNE fois vers lui et s'efface avant de
     l'atteindre — le même motif que le pied de page. Jamais sur la photo du haut, le texte, les boutons ni le
     chercheur : tout est calculé ici depuis leurs boîtes ; bande < 48 px → rien (classe is-m absente). */
  var cielTel = null;
  function calerCielTel(ciel, hero) {
    if (window.innerWidth >= 768) { ciel.classList.remove('is-m'); cielTel = null; return; }
    var q = hero.getBoundingClientRect(), bas = 0;
    var ob = hero.querySelectorAll('.bksaa-hero__body, .bksaa-finder, .bksaa-hero__cta, .bksaa-hero__soc');
    for (var i = 0; i < ob.length; i++) { var r = ob[i].getBoundingClientRect(); if (r.height > 0 && r.bottom > bas) bas = r.bottom; }
    var bande = q.bottom - bas;
    if (!bas || bande < 48) { ciel.classList.remove('is-m'); cielTel = null; return; }
    /* la bulle WhatsApp (position fixe, lot finition) : on réserve son emprise LA PLUS LARGE. Mesuré au rejeu :
       elle change d'état (languette de 20 px au bord, puis rond de 55 px ; 60 px au bureau) — lire sa largeur
       du moment plaçait le croissant SOUS le rond quelques secondes plus tard (360 × 740). Absente → 16 px. */
    var W = window.innerWidth, xb = W - 16, wa = document.querySelector('.bks-whatsapp-widget');
    if (wa) {
      var cs = getComputedStyle(wa), dr = parseFloat(cs.right);
      if (cs.display !== 'none' && cs.position === 'fixed') xb = Math.min(xb, W - Math.max(isNaN(dr) ? 20 : dr, 20) - Math.max(wa.offsetWidth, 60));
    }
    var haut = bas - q.top, lx = Math.round(xb - 14 - 22), ly = Math.round(haut + (bande - 22) / 2 - 7);
    var sy = Math.round(haut + (bande - 28) / 2 + 3), fin = Math.round(lx - 12 - 56);
    if (fin < 120) { ciel.classList.remove('is-m'); cielTel = null; return; }
    ciel.style.setProperty('--bks-hw-ml-x', lx + 'px');
    ciel.style.setProperty('--bks-hw-ml-y', ly + 'px');
    ciel.style.setProperty('--bks-hw-ms-y', sy + 'px');
    ciel.style.setProperty('--bks-hw-ms-fin', fin + 'px');
    ciel.classList.add('is-m');
    cielTel = { haut: haut, bande: bande, piste: sy };
  }
  /* La sorcière ne traverse la lune qu'UNE fois : il faut qu'on la VOIE. Mesuré sur l'aperçu réel : à la
     première visite, la traversée (2,6 s après l'arrivée) avait lieu SOUS le bandeau de consentement, puis la
     pop-up prenait l'écran — personne ne la voyait. Elle part donc (1,2 s plus tard) quand : aucun bandeau de
     consentement à l'écran, aucune pop-up ouverte ni en attente, aucun tiroir ouvert, l'onglet visible et le
     héros dans la fenêtre. Après la pop-up refermée, c'est elle qui passe. Guet arrêté au bout de 3 min. */
  function guetterTraversee(ciel, hero) {
    var debut = Date.now(), id = setInterval(function () {
      if (eteinte || Date.now() - debut > 180000) { clearInterval(id); return; }
      if (document.visibilityState === 'hidden' || ouverte || ouvertureId || sondeId || bandeauAffiche() || couvercle()) return;
      var q = hero.getBoundingClientRect();
      if (window.innerWidth < 768) {
        /* téléphone : la PISTE de la sorcière (sa hauteur + 8 px) doit être entièrement à l'écran. Aperçu réel :
           exiger toute la bande retenait la sorcière sur la LP à 390 × 844 (bande à 785 → 853, 9 px sous le
           pli) alors que sa piste (806 → 834) se voyait ; 375 × 667 : piste sous le pli → elle attend qu'on
           descende un peu. */
        if (!cielTel || !ciel.classList.contains('is-m')) return;
        if (q.top + cielTel.piste - 8 < 0 || q.top + cielTel.piste + 36 > window.innerHeight) return;
      } else if (q.bottom < window.innerHeight * .45 || q.top > window.innerHeight * .3) return;
      clearInterval(id);
      ciel.classList.add('is-traverse');
    }, 400);
  }

  /* ------------------------------------------------------------------ 4. la pop-up */
  var COMPANY_ID = 'UV7NE3';      /* clé PUBLIQUE Klaviyo, la même que la pop-up WELCOME10 */
  /* LISTE (02/10, tour 1 — contrat du lot « flux », site/rapports/0210-flux.md § 3.4) : U9RTDS « BKS · Halloween 2026
     — pop-up, barre, fiches », inscription simple, AUCUN flux déclenché par la liste. Jusqu'ici pop-up et barre
     inscrivaient dans SwkYBi (flux live « MICKA » → WELCOME10 envoyée À CÔTÉ du code d'Halloween) et les fiches dans
     RtetVe (flux live « [FLUX 2] » → le code de la rentrée, mort). Le code part du flux WcqNdY du lot « flux », déclenché par le
     segment Y7HcrT (Campagne = « Halloween 2026 », posée ci-dessous) ; il suit « a acheté / n'a pas acheté ». */
  var LIST_ID = 'U9RTDS';
  var C_FERME = 'bks_hw_pop_d';   /* fermée → on ne la remontre pas avant 7 j (et jamais après la fin) */
  /* (C_INSCRIT, LS_OK, lireCookie, lsLire, lsPoser : § 2, partagés avec la capture des fiches) */
  /* v2 (correction a) : MÊME délai que la WELCOME10 (SHOW_DELAY = 4500 dans snippets/popup-cross-bks.liquid),
     au lieu de 6 s ; même silence de 7 j si fermée. */
  var DELAI = 4500, DELAI_APRES_DECISION = 2200, ATTENTE_MAX = 30000, PAS_SONDE = 300;
  var CROCHETS_CONSENT = '.cookiefirst-root, [data-cookiefirst-widget], [data-cookiefirst-action], [data-cookiefirst-accent-color]';

  function poserCookie(n, v, ms) {
    var exp = Math.min(Date.now() + ms, C.fin + 864e5);   /* aucun cookie d'Halloween ne survit au 01/11 */
    document.cookie = n + '=' + v + ';expires=' + new Date(exp).toUTCString() + ';path=/;SameSite=Lax';
  }

  var pop = null, carte = null, ouverte = false, envoiEnCours = false, focusAvant = null, debordementAvant = '';
  var sondeId = null, gardienId = null, ouvertureId = null, bandeauVu = false, T0 = Date.now();

  /* 02/10 (recette technique) — LA MÊME FRÉQUENCE QUE LA WELCOME10, DANS LES DEUX SENS. La pop-up Halloween prend
     la place de la WELCOME10 (gelée, snippets/popup-cross-bks.liquid) pendant octobre ; elle lit donc ses marques
     ET pose les siennes, pour que le visiteur ne voie jamais une pop-up de trop, ni en octobre ni le 01/11 :
       · inscrit à la WELCOME10 (bks_pop_w10_s, 30 j)         → pas de pop-up Halloween (déjà sur la liste) ;
       · WELCOME10 fermée il y a moins de 7 j (bks_pop_w10_d)  → pas de pop-up Halloween avant la fin des 7 j
         (avant ce jour, la règle n'était pas reprise : un visiteur qui venait de la fermer voyait la suivante) ;
       · inscrit par la pop-up Halloween → on pose AUSSI bks_pop_w10_s (30 j, cookie + stockage, exactement comme
         la WELCOME10 le fait l. 756-757) : sinon, dès le 01/11, la WELCOME10 lui redemandait son e-mail pour la
         liste SwkYBi (et un 2e code, WELCOME10, à quelqu'un déjà abonné au marketing par Halloween) ;
       · pop-up Halloween fermée → on pose AUSSI bks_pop_w10_d (7 j) : la WELCOME10 respecte le même silence.
     Ces deux cookies-là ne passent PAS par poserCookie (qui plafonne au 01/11) : ils servent justement après. */
  var W10_INSCRIT = 'bks_pop_w10_s', W10_FERME = 'bks_pop_w10_d';
  function poserCookieW10(n, jours) {
    document.cookie = n + '=1;expires=' + new Date(Date.now() + jours * 864e5).toUTCString() + ';path=/;SameSite=Lax';
  }
  function popDesiree() {
    if (!C.popup || !document.getElementById('bks-hw-pop-gabarit')) return false;
    if (lireCookie(C_INSCRIT) || lireCookie(C_FERME) || lsLire(LS_OK) === '1') return false;
    /* déjà inscrit par la pop-up WELCOME10 : il recevra l'offre par e-mail, on ne le relance pas ; WELCOME10
       fermée il y a moins de 7 jours : même silence qu'elle (règle de fréquence reprise le 02/10) */
    if (lireCookie(W10_INSCRIT) || lsLire(W10_INSCRIT) || lireCookie(W10_FERME)) return false;
    /* la WELCOME10 n'a pas pu être retirée (navigateur exotique) : elle garde la place, jamais deux pop-ups */
    if (document.getElementById('bks-pop-overlay')) return false;
    return true;
  }

  function visible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    if (r.width < 40 || r.height < 24) return false;
    var c = window.getComputedStyle(el);
    return c.display !== 'none' && c.visibility !== 'hidden' && parseFloat(c.opacity) > 0.05;
  }
  function bandeauAffiche() {
    var n; try { n = document.querySelectorAll(CROCHETS_CONSENT); } catch (e) { return false; }
    for (var i = 0; i < n.length; i++) if (visible(n[i])) return true;
    return false;
  }
  function decisionPrise() { var CF = window.CookieFirst; if (!CF) return false; try { return !!CF.consent; } catch (e) { return false; } }

  /* Un COUVERCLE = un tiroir / une fenêtre du thème Prestige ouvert (menu, panier, recherche, achat rapide,
     choix de langue…) : jamais deux couches modales. La fenêtre de CookieFirst est gérée par bandeauAffiche().
     On attend aussi qu'un visiteur qui TAPE ait fini : jamais de pop-up sous ses doigts. */
  var COUVERCLES = 'header-sidebar[open], cart-drawer[open], header-search[open], quick-buy-drawer[open], quick-buy-modal[open], ' +
    'x-drawer[open], x-modal[open], x-popover[open], .drawer[open], .modal[open], dialog[open]:not(.cookiefirst-root)';
  var couvercleVu = false, DELAI_APRES_COUVERCLE = 4000;
  function couvercle() {
    var n; try { n = document.querySelectorAll(COUVERCLES); } catch (e) { return false; }
    for (var i = 0; i < n.length; i++) {
      if (pop && pop.contains(n[i])) continue;
      if (n[i].closest && n[i].closest('.cookiefirst-root, [data-cookiefirst-widget]')) continue;
      return true;
    }
    return false;
  }
  function saisie() {
    var a = document.activeElement;
    if (!a || a === document.body || (pop && pop.contains(a))) return false;
    if (a.isContentEditable || a.tagName === 'TEXTAREA') return true;
    return a.tagName === 'INPUT' && /^(text|email|search|tel|number|password|url|)$/i.test(a.getAttribute('type') || '');
  }
  function gene() { if (couvercle() || saisie()) { couvercleVu = true; return true; } return false; }

  /* v2 (correction a) — CONFIGURATEURS : la pop-up y remplace aussi la WELCOME10, mais sans gêner la
     configuration. On n'ouvre qu'après REPOS_CONFIG ms sans aucun geste (clic, toucher, touche, molette,
     saisie, choix dans une liste) : un visiteur qui choisit ses couleurs n'est jamais interrompu ; s'il ne
     touche à rien, elle vient au même moment que la WELCOME10 (4,5 s). */
  var REPOS_CONFIG = 4500, dernierGeste = Date.now();
  if (C.config) {
    var gestes = ['pointerdown', 'keydown', 'wheel', 'touchstart', 'input', 'change'];
    for (var gi = 0; gi < gestes.length; gi++) document.addEventListener(gestes[gi], function (e) { if (!pop || !pop.contains(e.target)) dernierGeste = Date.now(); }, { capture: true, passive: true });
  }
  function auRepos() { return !C.config || (Date.now() - dernierGeste) >= REPOS_CONFIG; }

  function peutOuvrir() {
    if (bandeauAffiche()) return false;              /* jamais par-dessus le consentement */
    if (gene()) return false;                        /* jamais par-dessus un tiroir ouvert, ni pendant une saisie */
    if (!auRepos()) return false;                    /* configurateur : jamais pendant qu'on configure */
    if (decisionPrise()) return true;
    return (Date.now() - T0) >= ATTENTE_MAX;         /* filet : CookieFirst absent ou bloqué */
  }

  function construirePop() {
    if (pop) return true;
    var g = document.getElementById('bks-hw-pop-gabarit');
    if (!g || !g.content) return false;
    pop = g.content.firstElementChild.cloneNode(true);
    document.body.appendChild(pop);
    carte = pop.querySelector('.bks-hw-pop__carte');
    pop.querySelector('[data-bks-hw-fermer]').addEventListener('click', function () { fermerPop(true); });
    pop.querySelector('[data-bks-hw-continuer]').addEventListener('click', function () { fermerPop(false); });
    pop.addEventListener('mousedown', function (e) { if (e.target === pop) fermerPop(true); });
    pop.querySelector('[data-bks-hw-form]').addEventListener('submit', envoyer);
    var champs = pop.querySelectorAll('.bks-hw-champ, .bks-hw-accord__case');
    for (var i = 0; i < champs.length; i++) champs[i].addEventListener(champs[i].type === 'checkbox' ? 'change' : 'input', function () { this.classList.remove('is-invalide'); erreur(''); });
    /* visiteur venu d'une publicité : le code est déjà dans la barre — les textes le disent (le gabarit porte les deux) */
    if (C.pub) {
      var t = pop.querySelectorAll('[data-bks-hw-pub-txt]');
      for (var k = 0; k < t.length; k++) t[k].textContent = t[k].getAttribute('data-bks-hw-pub-txt');
    }
    majChronos();
    return true;
  }

  /* la capture ouverte par un GESTE du visiteur (bouton de la barre, ou copie sans droit) : partout, sans les
     règles de fréquence de la pop-up automatique ; déjà inscrit → la pop-up s'ouvre directement sur son code */
  var canal = 'popup';
  function ouvrirCapture(c, origine) {
    if (eteinte || !enCours() || !construirePop()) return;
    canal = c || 'popup';
    if (ouvertureId) { clearTimeout(ouvertureId); ouvertureId = null; }
    arreterSonde();
    if (estInscrit()) etapeOk('');
    ouvrirPop(true);
    if (origine) focusAvant = origine;
  }
  function etapeOk(prenom) {
    var p = pop.querySelector('[data-bks-hw-prenom]');
    if (p) p.textContent = prenom ? ', ' + prenom : '';
    pop.querySelector('[data-bks-hw-etape="form"]').hidden = true;
    pop.querySelector('[data-bks-hw-etape="ok"]').hidden = false;
    carte.setAttribute('aria-labelledby', 'bks-hw-pop-ok-titre');
    carte.removeAttribute('aria-describedby');
    montrerCodes();
  }

  var FOCUSABLES = 'button:not([disabled]), input:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])';
  function auClavier(e) {
    if (!ouverte) return;
    if (e.key === 'Escape') { e.preventDefault(); fermerPop(true); return; }
    if (e.key !== 'Tab') return;
    var l = Array.prototype.filter.call(carte.querySelectorAll(FOCUSABLES), function (el) { return el.offsetWidth > 0 || el.offsetHeight > 0; });
    if (!l.length) { e.preventDefault(); carte.focus(); return; }
    var a = l[0], z = l[l.length - 1];
    if (e.shiftKey && (document.activeElement === a || document.activeElement === carte)) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  }

  function ouvrirPop(parGeste) {
    if (ouverte || eteinte || !enCours() || !construirePop()) return;
    ouverte = true;
    focusAvant = document.activeElement;
    pop.classList.add('is-ouverte');
    pop.setAttribute('aria-hidden', 'false');
    debordementAvant = html.style.overflow;
    html.style.overflow = 'hidden';
    requestAnimationFrame(function () { requestAnimationFrame(function () { if (pop) pop.classList.add('is-visible'); }); });
    /* la CARTE prend le focus, pas le champ : pas de clavier mobile qui surgit à l'ouverture */
    setTimeout(function () { if (ouverte) { try { carte.focus({ preventScroll: true }); } catch (e) {} } }, 60);
    document.addEventListener('keydown', auClavier, true);
    /* ouverte par un geste du visiteur : il l'a demandée, le gardien (qui l'efface devant un tiroir ou le bandeau de
       consentement qui revient) ne s'applique qu'à l'ouverture automatique */
    if (!parGeste) lancerGardien();
  }

  function fermerPop(retenir) {
    if (!ouverte || !pop) return;
    ouverte = false;
    pop.classList.remove('is-visible');
    document.removeEventListener('keydown', auClavier, true);
    if (retenir) { poserCookie(C_FERME, '1', 7 * 864e5); poserCookieW10(W10_FERME, 7); }
    html.style.overflow = debordementAvant;
    var p = pop;
    setTimeout(function () { p.classList.remove('is-ouverte'); p.setAttribute('aria-hidden', 'true'); }, 320);
    if (focusAvant && focusAvant.focus) { try { focusAvant.focus({ preventScroll: true }); } catch (e) {} }
    if (p.contains(document.activeElement)) { try { document.activeElement.blur(); } catch (e) {} }
  }

  function erreur(t) { var e = pop && pop.querySelector('[data-bks-hw-err]'); if (e) e.textContent = t; }
  function dire(t) { var d = pop && pop.querySelector('[data-bks-hw-direct]'); if (d) d.textContent = t; }

  /* ---- L'INSCRIPTION (les deux captures). Prénom, nom, e-mail et case de consentement OBLIGATOIRES (Ludo, 02/10).
     Même appel que la pop-up WELCOME10 (client/subscriptions, clé publique UV7NE3). RÉVISION 2026-07-15 et non plus 2024-10-15 :
     Klaviyo répond à 2024-10-15 avec « x-klaviyo-api-retirement-date: 2026-10-15 » (relevé le 02/10) — elle prend sa retraite
     EN PLEINE CAMPAGNE ; la même charge est acceptée telle quelle en 2026-07-15 (essai curl, e-mail invalide : seule l'adresse
     est refusée, la structure passe). La liste
     et la source viennent de l'appelant (pop-up, barre et fiches : U9RTDS, voir LIST_ID). Les
     propriétés posées sur le profil sont le CONTRAT avec le lot « flux » (flux Klaviyo qui envoie le code) :
       Campagne « Halloween 2026 » · Canal popup | barre | produit · Source · Code_Promo · Origine_Pub oui | non ·
       Consentement_Halloween (date ISO de la case cochée) · first_name / last_name (champs standard).
     Le code n'est mis dans la charge qu'AU MOMENT de l'envoi (codeClair) : il n'est écrit nulle part avant. */
  var MAIL_OK = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i;
  function verifierChamps(fn, nm, em, ac) {
    var r = { prenom: fn.value.trim(), nom: nm.value.trim(), mail: em.value.trim(), accord: !!ac.checked, champ: null, msg: '' };
    var manque = [];
    if (!r.prenom) { fn.classList.add('is-invalide'); manque.push('ton prénom'); r.champ = r.champ || fn; }
    if (!r.nom) { nm.classList.add('is-invalide'); manque.push('ton nom'); r.champ = r.champ || nm; }
    /* 05/10 au soir (vérificateur technique, tour 1) : les 3 champs vides donnaient « Il nous faut ton prénom et ton nom pour
       t'envoyer ton code. » — le champ e-mail était bien entouré, mais le message (role=alert, lu par les lecteurs d'écran)
       ne le nommait pas. Un e-mail VIDE manque comme les deux autres ; un e-mail rempli mais mal formé garde son message. */
    if (!r.mail) { em.classList.add('is-invalide'); manque.push('ton e-mail'); r.champ = r.champ || em; }
    else if (!MAIL_OK.test(r.mail)) { em.classList.add('is-invalide'); r.champ = r.champ || em; }
    if (manque.length) r.msg = 'Il nous faut ' + (manque.length > 1 ? manque.slice(0, -1).join(', ') + ' et ' + manque[manque.length - 1] : manque[0]) + ' pour t\'envoyer ton code.';
    else if (!MAIL_OK.test(r.mail)) r.msg = 'Cet e-mail ne semble pas valide. Vérifie-le et réessaie.';
    else if (!r.accord) { ac.classList.add('is-invalide'); r.champ = ac; r.msg = 'Coche la case pour recevoir ton code et les offres de l\'atelier par e-mail.'; }
    return r;
  }
  function inscrire(v, liste, source, canalDit) {
    var ctrl = null, coupe = null;
    try { if (window.AbortController) ctrl = new AbortController(); } catch (x) {}
    var opts = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2026-07-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: {
        custom_source: source,
        profile: { data: { type: 'profile', attributes: { email: v.mail, first_name: v.prenom, last_name: v.nom, properties: {
          Source: source.toLowerCase().replace(/[^a-z0-9]+/g, '_'), Canal: canalDit, Campagne: 'Halloween 2026', Code_Promo: codeClair(),
          Origine_Pub: C.pub ? 'oui' : 'non', Consentement_Halloween: new Date().toISOString() } } } }
      }, relationships: { list: { data: { type: 'list', id: liste } } } } })
    };
    if (ctrl) { opts.signal = ctrl.signal; coupe = setTimeout(function () { try { ctrl.abort(); } catch (x) {} }, 15000); }
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY_ID, opts).then(function (r) {
      if (coupe) clearTimeout(coupe);
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r;
    }, function (x) { if (coupe) clearTimeout(coupe); throw x; });
  }
  function marquerInscrit() {
    poserCookie(C_INSCRIT, '1', 60 * 864e5);
    lsPoser(LS_OK, '1');
    /* la marque « inscrit » de la WELCOME10, comme elle la pose elle-même (30 j, cookie + stockage) */
    poserCookieW10(W10_INSCRIT, 30);
    lsPoser(W10_INSCRIT, '1');
    html.classList.add('bks-hw-inscrit');
    montrerCodes();
    initCaptures();
  }

  function envoyer(e) {
    e.preventDefault();
    if (envoiEnCours) return;
    erreur('');
    var v = verifierChamps(pop.querySelector('#bks-hw-pop-prenom'), pop.querySelector('#bks-hw-pop-nom'), pop.querySelector('#bks-hw-pop-email'), pop.querySelector('#bks-hw-pop-accord'));
    if (v.msg) { erreur(v.msg); try { v.champ.focus(); } catch (x) {} return; }
    envoiEnCours = true;
    var bouton = pop.querySelector('[data-bks-hw-envoyer]'), lib = pop.querySelector('[data-bks-hw-libelle]');
    var lib0 = lib.innerHTML;
    bouton.disabled = true; bouton.classList.add('is-attente'); lib.textContent = 'Un instant…';
    function echec() {
      envoiEnCours = false; bouton.disabled = false; bouton.classList.remove('is-attente'); lib.innerHTML = lib0;
      erreur('Petit souci de connexion. Réessaie dans un instant.');
    }
    var req;
    try { req = inscrire(v, LIST_ID, 'Popup Halloween 2026', canal); } catch (x) { echec(); return; }
    /* .then(succès, échec) : une exception DANS le succès ne doit jamais afficher « souci » à un inscrit */
    req.then(function () {
      envoiEnCours = false;
      marquerInscrit();
      etapeOk(v.prenom);
      dire('Inscription confirmée. Ton code est ' + codeClair() + '.' + (C.mailCode ? ' Il arrive aussi par e-mail.' : ''));
      setTimeout(function () { var c = pop.querySelector('.bks-hw-ticket__copier'); if (c) try { c.focus(); } catch (x) {} }, 80);
    }, echec);
  }

  /* ---- LA CAPTURE DES FICHES (snippets/bks-rentree-capture.liquid) : tout son comportement est ICI, par délégation.
     Mesuré le 02/10 dans assets/theme.js (ProductRerender) : au changement de variante, Prestige REMPLACE tous les
     blocs « liquid » de la colonne d'achat par ceux du nouveau rendu ; leurs scripts en ligne ne s'exécutent pas →
     un formulaire branché par son propre script ne répondait plus après un changement de couleur. Ici : un seul
     écouteur sur le document, et chaque capture (re)née est remise dans le bon état (inscrit → son code). */
  function initCaptures() {
    var l = document.querySelectorAll('[data-bks-cap]');
    for (var i = 0; i < l.length; i++) {
      var r = l[i];
      if (estInscrit() && !r.hasAttribute('data-bks-cap-ok')) {
        var p = r.querySelectorAll('[data-bks-cap-part]');
        for (var k = 0; k < p.length; k++) p[k].hidden = true;
        var ok = r.querySelector('[data-bks-cap-merci]');
        if (ok) ok.hidden = false;
        r.setAttribute('data-bks-cap-ok', '');
      }
      armer(r);
      if (C.chrono) C.chrono(r);
    }
    montrerCodes();
  }
  /* 05/10 (vérificateur technique, tour 1) : le bouton de la capture arrive DÉSACTIVÉ du serveur et n'est activé qu'ici,
     quand l'écouteur `submit` ci-dessous est posé. Avant, un clic tombé avant ce script envoyait le formulaire à la
     manière du navigateur (GET : prénom, nom, e-mail dans l'URL ; personne d'inscrit). Jamais pendant un envoi en cours.
     Exposé à la capture : son script en ligne l'appelle si ce fichier a déjà tourné. */
  function armer(r) {
    if (eteinte || !r || !r.querySelectorAll || r.hasAttribute('data-bks-cap-envoi')) return;
    var b = r.querySelectorAll('[data-bks-cap-form] button[type="submit"]');
    for (var i = 0; i < b.length; i++) if (b[i].disabled) b[i].disabled = false;
  }
  C.armer = armer;
  document.addEventListener('submit', function (e) {
    var f = e.target && e.target.closest ? e.target.closest('[data-bks-cap-form]') : null;
    if (!f) return;
    e.preventDefault();
    if (eteinte) return;   /* éteinte en direct : la capture reste en place, invisible et inerte, et n'envoie plus rien */
    var r = f.closest('[data-bks-cap]');
    if (!r || r.hasAttribute('data-bks-cap-envoi')) return;
    var err = r.querySelector('[data-bks-cap-err]');
    err.textContent = '';
    var v = verifierChamps(f.querySelector('[name="prenom"]'), f.querySelector('[name="nom"]'), f.querySelector('[name="email"]'), r.querySelector('[name="accord"]'));
    if (v.msg) { err.textContent = v.msg; try { v.champ.focus(); } catch (x) {} return; }
    var btn = f.querySelector('button[type="submit"]'), lbl = btn.querySelector('[data-bks-cap-lib]') || btn, lbl0 = lbl.innerHTML;
    r.setAttribute('data-bks-cap-envoi', '');
    btn.disabled = true; lbl.textContent = 'Un instant…';
    inscrire(v, r.getAttribute('data-bks-cap-liste') || LIST_ID, r.getAttribute('data-bks-cap-source') || 'Bouton Produit Halloween 2026', 'produit').then(function () {
      r.removeAttribute('data-bks-cap-envoi');
      var n = r.querySelector('[data-bks-cap-prenom]');
      if (n) n.textContent = ', ' + v.prenom;
      marquerInscrit();
      var d = r.querySelector('[role="status"]');
      if (d) d.textContent = 'Inscription confirmée. Ton code est ' + codeClair() + '.' + (C.mailCode ? ' Il arrive aussi par e-mail.' : '');
    }, function () {
      r.removeAttribute('data-bks-cap-envoi');
      btn.disabled = false; lbl.innerHTML = lbl0;
      err.textContent = 'Petit souci de connexion. Réessaie dans un instant.';
    });
  }, true);
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.closest || !t.closest('[data-bks-cap]')) return;
    t.classList.remove('is-invalide');
    var err = t.closest('[data-bks-cap]').querySelector('[data-bks-cap-err]');
    if (err) err.textContent = '';
  }, true);

  function arreterSonde() { if (sondeId) { clearInterval(sondeId); sondeId = null; } }
  function lancerSonde() { if (sondeId || ouverte) return; sondeId = setInterval(sonder, PAS_SONDE); sonder(); }
  function sonder() {
    if (ouverte || ouvertureId || eteinte) return;
    /* configurateur : tant que le bandeau de consentement est à l'écran, le visiteur est OCCUPÉ (il lit, il choisit) —
       c'est un geste qui dure. Mesuré sur l'aperçu réel le 02/10 : un refus fait par un clic SANS événement de
       pointeur (clic de script, d'outil d'accessibilité, consentement posé par une extension) n'était pas vu comme
       un geste → pop-up 2,4 à 3,0 s après la fermeture du bandeau. La disparition du bandeau compte désormais comme
       le dernier geste : 4,5 s de calme APRÈS elle, quelle que soit la façon dont il a été fermé. */
    if (bandeauAffiche()) { bandeauVu = true; if (C.config) dernierGeste = Date.now(); return; }
    if (!peutOuvrir()) return;
    arreterSonde();
    /* après un tiroir refermé : 4 s de répit (on ne surgit pas à la seconde où le visiteur revient à la page).
       02/10 (recette technique) — CONFIGURATEUR : la porte auRepos() (4,5 s SANS geste) est déjà la respiration ;
       on n'y ajoute plus les 2,2 s « après la décision de consentement » : mesuré hier sur l'aperçu réel, 1re visite
       (bandeau vu puis refusé) → ouverture 7,0 s après le dernier geste au lieu des 4,5 s annoncés. Désormais :
       4,5 s après le dernier geste (la fermeture du bandeau en est un), dans tous les cas. Ailleurs : inchangé,
       le rythme exact de la WELCOME10 (4,5 s après l'arrivée, ou 2,2 s après la décision de consentement). */
    var reste = C.config ? (couvercleVu ? DELAI_APRES_COUVERCLE : 0)
      : Math.max(couvercleVu ? DELAI_APRES_COUVERCLE : 0, bandeauVu ? DELAI_APRES_DECISION : Math.max(0, DELAI - (Date.now() - T0)));
    couvercleVu = false;
    ouvertureId = setTimeout(function () {
      ouvertureId = null;
      /* revérifié au dernier moment : un tiroir a pu s'ouvrir, un geste a pu tomber pendant l'attente */
      if (bandeauAffiche()) { bandeauVu = true; lancerSonde(); return; }
      if (gene() || !auRepos()) { lancerSonde(); return; }
      if (popDesiree()) ouvrirPop();
    }, reste);
  }
  function lancerGardien() {
    if (gardienId) return;
    gardienId = setInterval(function () {
      if (!ouverte) { clearInterval(gardienId); gardienId = null; return; }
      /* le consentement (ré)apparaît, ou un tiroir s'ouvre malgré tout (raccourci, script tiers) : la pop-up
         s'efface sans cookie de fermeture et revient plus tard — jamais deux couches modales à la fois */
      var cf = bandeauAffiche();
      if (!cf && !couvercle()) return;
      clearInterval(gardienId); gardienId = null;
      if (cf) bandeauVu = true; else couvercleVu = true;
      fermerPop(false);
      setTimeout(lancerSonde, 400);
    }, 500);
  }

  /* ------------------------------------------------------------------ 5. chapeaux, balais, citrouilles (v2) */
  function motif(cls, id, vb, balise) {
    var s = document.createElement(balise || 'span');
    s.className = 'bks-hw-deco ' + cls;
    s.setAttribute('aria-hidden', 'true');
    s.setAttribute('data-bks-hw-retirer', '');
    s.innerHTML = svgUse(id, vb);
    return s;
  }

  /* 5a. LE CHAPEAU SUR LA PREMIÈRE LETTRE DU TITRE. On mesure la lettre telle qu'elle est DESSINÉE :
     Range → boîte du caractère ; canevas → métrique de la police (montée, haut réel du glyphe, flancs).
     Le chapeau est un enfant ABSOLU du titre (aucun texte touché, aucun nœud de texte coupé) ; il n'est pas
     posé si sa boîte toucherait un autre texte, une image ou une commande (fil d'Ariane, date, galerie…). */
  var TITRES = { product: 1, article: 1, blog: 1, page: 1, cart: 1, search: 1, 'list-collections': 1 };
  var cv = null, chapeaux = [];
  function premierTexte(el) {
    var tw = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n;
    while ((n = tw.nextNode())) if (/\S/.test(n.nodeValue) && n.parentElement && !n.parentElement.closest('.bks-hw-chapeau')) return n;
    return null;
  }
  function mesurerLettre(h) {
    var n = premierTexte(h); if (!n) return null;
    var i = n.nodeValue.search(/\S/), c = n.nodeValue.charAt(i);
    if (!/[A-Za-z0-9À-ɏ]/.test(c)) return null;
    var r = document.createRange(); r.setStart(n, i); r.setEnd(n, i + 1);
    var q = r.getBoundingClientRect(); if (!q.width || !q.height) return null;
    var cs = getComputedStyle(n.parentElement), fs = parseFloat(cs.fontSize) || 16;
    if (cs.textTransform === 'uppercase') c = c.toUpperCase();
    /* les 3 premiers caractères, pour le dessin réel de l'encre sous le bord du chapeau (voir `encre`) */
    var debut = n.nodeValue.substr(i, 3).replace(/\s+/g, ' ');
    if (cs.textTransform === 'uppercase') debut = debut.toUpperCase();
    try { cv = cv || document.createElement('canvas').getContext('2d'); cv.font = cs.fontStyle + ' ' + cs.fontWeight + ' ' + fs + 'px ' + cs.fontFamily; } catch (e) { return null; }
    var mt = cv.measureText(c), asc = mt.fontBoundingBoxAscent, desc = mt.fontBoundingBoxDescent;
    var ligne = (asc && desc) ? q.top + (q.height - (asc + desc)) / 2 + asc : q.top + q.height * .78;
    return { haut: ligne - (mt.actualBoundingBoxAscent || fs * .7), g: q.left - (mt.actualBoundingBoxLeft || 0), d: q.left + (mt.actualBoundingBoxRight || q.width), fs: fs, couleur: cs.color,
      stylo: q.left, base: ligne, encre: encre(debut, cs, fs) };
  }
  function clair(rgb) {
    var m = String(rgb).match(/\d+(\.\d+)?/g); if (!m) return false;
    return (0.2126 * m[0] + 0.7152 * m[1] + 0.0722 * m[2]) / 255 > 0.6;
  }
  function boitesVoisines(h) {
    /* textes, images et commandes proches du titre (3 niveaux au-dessus), le titre lui-même exclu */
    var racine = h.parentElement && h.parentElement.parentElement ? (h.parentElement.parentElement.parentElement || h.parentElement.parentElement) : document.body;
    var out = [], tw = document.createTreeWalker(racine, NodeFilter.SHOW_TEXT, null), n, k;
    while ((n = tw.nextNode())) {
      if (!/\S/.test(n.nodeValue) || h.contains(n) || !n.parentElement || n.parentElement.closest('script,style,template,.bks-hw-barre,.bks-hw-pop')) continue;
      var r = document.createRange(); r.selectNodeContents(n);
      var l = r.getClientRects(); for (k = 0; k < l.length; k++) if (l[k].width > 0) out.push(l[k]);
    }
    var els = racine.querySelectorAll('img, video, button, a, input, select, textarea');
    for (k = 0; k < els.length; k++) if (!h.contains(els[k])) { var b = els[k].getBoundingClientRect(); if (b.width > 0) out.push(b); }
    /* l'en-tête (collant) ne compte que page en haut : plus bas, il passe AU-DESSUS du titre en défilant */
    var entete = document.querySelector('.shopify-section--header');
    if (entete && (window.scrollY || window.pageYOffset || 0) < 5) out.push(entete.getBoundingClientRect());
    return out;
  }
  /* tailles essayées, de la plus généreuse à la plus discrète (en part du corps du titre) : on garde la
     première qui ne touche rien ; aucune ne passe → pas de chapeau sur cette page */
  var TAILLES = [.9, .78, .66, .56];
  /* plancher de 28 px pour les deux premières tailles : sur téléphone le titre d'une fiche fait ~26 px de
     corps, et un chapeau de 23 px se lisait comme une tache (aperçu réel, fiche 390) ; et jamais moins de
     24 px, quelle que soit la taille essayée (en dessous : pas de chapeau plutôt qu'une tache) */
  var PLANCHER = 28, MINI = 24;
  /* Tour 1 (vérificateur, article 1440) : la pointe arrivait à 4-5 px sous la date « 6 avr. 2026 » — le test
     rétrécissait la boîte de 2 px. Désormais la boîte est AGRANDIE de 6 px (de l'air autour du chapeau) et
     calculée, pas lue : rectangle du chapeau tourné de −14° autour de son point d'appui (50 % / 92 %), à sa
     position FINALE — getBoundingClientRect() lisait l'animation de pose en cours (chapeau 30 % plus haut).
     3 assises essayées par taille : posé sur la lettre (bord à 5 % du corps), puis enfoncé (14 %, 22 %). */
  var AIR = 6, INCL = -14 * Math.PI / 180, ASSISES = [.05, .14, .22];
  function boiteChapeau(x, y, w, hh) {
    var ox = x + w * .5, oy = y + hh * .92, c = Math.cos(INCL), s = Math.sin(INCL);
    var P = [[x, y], [x + w, y], [x, y + hh], [x + w, y + hh]], l = 1e9, r = -1e9, t = 1e9, b = -1e9;
    for (var i = 0; i < 4; i++) {
      var dx = P[i][0] - ox, dy = P[i][1] - oy, X = ox + dx * c - dy * s, Y = oy + dx * s + dy * c;
      if (X < l) l = X; if (X > r) r = X; if (Y < t) t = Y; if (Y > b) b = Y;
    }
    return { left: l, right: r, top: t, bottom: b };
  }
  /* 05/10 au soir (vérificateur design, tour 1) — LE CHAPEAU SE POSE SUR LE DESSIN RÉEL DE LA LETTRE, JAMAIS DEDANS.
     Avant : bord posé à 5 % du corps DANS la lettre (14 %, 22 % s'il manquait d'air au-dessus), puis incliné de −14° : son
     bout gauche descend encore d'environ 0,11 × la largeur du chapeau. Sur une lettre à barre haute, le bord — de la même
     encre que le texte — mangeait la moitié gauche de la barre : « †on panier » (panier vide et plein, 390 et 1440) et le F
     de « FORCE GRIP » sans sa barre (agrandissements du vérificateur). Désormais les 3 premiers caractères du titre sont
     dessinés sur un canevas (même police, même corps, même interlettrage), on relève colonne par colonne le HAUT de l'encre,
     et le bas du bord (ellipse du symbole : x 3 → 61, y 40,6 → 52,2 sur 64 × 56, incliné comme à l'écran autour de
     50 % / 92 %) descend jusqu'à TOUCHER l'encre, à TOL px près (lissage des bords). Une lettre ronde ou pointue (O, C, A)
     le reçoit sur son sommet, une barre (T, F, E) à plat. S'il manque d'air au-dessus à cette hauteur, la taille suivante
     est essayée (comme avant) ; aucune ne passe → pas de chapeau. Canevas illisible → les 3 assises d'avant. */
  var BORD = [], TOL = 1;
  for (var bu = 3; bu <= 61; bu++) BORD.push([bu, 46.4 + 5.8 * Math.sqrt(Math.max(0, 1 - Math.pow((bu - 32) / 29, 2)))]);
  function encre(txt, cs, fs) {
    try {
      var k = 2, W = Math.ceil(fs * 3.6 * k), H = Math.ceil(fs * 2 * k), ox = Math.round(fs * .5 * k), base = Math.round(fs * 1.4 * k);
      var cnv = document.createElement('canvas');
      cnv.width = W; cnv.height = H;
      var g = cnv.getContext('2d', { willReadFrequently: true });
      if (!g) return null;
      g.font = cs.fontStyle + ' ' + cs.fontWeight + ' ' + (fs * k) + 'px ' + cs.fontFamily;
      if ('letterSpacing' in g && cs.letterSpacing && cs.letterSpacing !== 'normal') g.letterSpacing = (parseFloat(cs.letterSpacing) * k) + 'px';
      g.textBaseline = 'alphabetic';
      g.fillStyle = '#000';
      g.fillText(txt, ox, base);
      var d = g.getImageData(0, 0, W, H).data, haut = [], vu = false;
      for (var x = 0; x < W; x++) {
        var t = null;
        for (var y = 0; y < H; y++) if (d[(y * W + x) * 4 + 3] > 96) { t = (y - base) / k; break; }
        if (t !== null) vu = true;
        haut.push(t);
      }
      return vu ? { haut: haut, ox: ox, k: k } : null;
    } catch (e) { return null; }
  }
  /* hauteur (haut de la boîte du chapeau) où le bas du bord touche l'encre ; null si on ne sait pas la mesurer */
  function repos(L, x, w) {
    var E = L.encre;
    if (!E) return null;
    var s = w / 64, co = Math.cos(INCL), si = Math.sin(INCL), y = null;
    for (var p = 0; p < BORD.length; p++) {
      var du = BORD[p][0] - 32, dv = BORD[p][1] - 51.52;
      var X = 32 + du * co - dv * si, Y = 51.52 + du * si + dv * co;
      var col = Math.round((x + X * s - L.stylo) * E.k + E.ox);
      if (col < 0 || col >= E.haut.length || E.haut[col] === null) continue;
      var lim = L.base + E.haut[col] + TOL - Y * s;
      if (y === null || lim < y) y = lim;
    }
    return y;
  }
  function placerChapeau(o) {
    var h = o.h, chap = o.chap, L = mesurerLettre(h);
    o.taille = 0;
    if (!L || L.fs < 18) { chap.style.display = 'none'; return; }
    var hr = h.getBoundingClientRect(), v = boitesVoisines(h), cx = (L.g + L.d) / 2;
    var x0 = hr.left + h.clientLeft, y0 = hr.top + h.clientTop;
    for (var t = 0; t < TAILLES.length; t++) {
      var w = Math.round(t < 2 ? Math.max(L.fs * TAILLES[t], PLANCHER) : L.fs * TAILLES[t]), hh = w * 56 / 64;
      if (w < MINI) continue;
      var x = cx - w * .55, yr = repos(L, x, w), ys = [];
      if (yr !== null) ys.push(yr);
      else for (var a0 = 0; a0 < ASSISES.length; a0++) ys.push(L.haut + L.fs * ASSISES[a0] - hh * .93);
      for (var a = 0; a < ys.length; a++) {
        var y = ys[a], b = boiteChapeau(x, y, w, hh), touche = false;
        for (var i = 0; i < v.length && !touche; i++) {
          var r = v[i];
          if (r.left < b.right + AIR && r.right > b.left - AIR && r.top < b.bottom + AIR && r.bottom > b.top - AIR) touche = true;
        }
        if (touche) continue;
        /* position par la propriété `translate` (et non left / top) : un déplacement par transformation n'est
           pas un « layout shift » — le chapeau peut être recalé quand la police arrive sans compter au CLS.
           On ne bascule display qu'une fois : chaque passage none → visible relancerait l'animation de pose
           (vu au rejeu : un chapeau à demi transparent 5 s après l'arrivée, remesuré à l'événement load). */
        chap.style.width = w + 'px';
        chap.style.translate = Math.round((x - x0) * 10) / 10 + 'px ' + Math.round((y - y0) * 10) / 10 + 'px';
        if (chap.style.display === 'none') chap.style.display = '';
        o.taille = TAILLES[t]; o.boite = b;
        chap.setAttribute('data-bks-hw-pose', yr !== null ? 'encre' : 'assise');   /* lu par les essais (M3) */
        return;
      }
    }
    chap.style.display = 'none';
  }
  /* Tour 1 (vérificateur) — FICHES DE CONFIGURATEUR (FUSION, VELTO, SCOOTER, CROSS, CUSTOM : gabarit produit) :
     elles n'avaient aucun motif hors barre et pop-up. Leur TITRE n'est pas la mécanique du configurateur :
     le chapeau du h1 (et lui seul) y est posé ; tout le reste y reste calme (ni ciel, ni bandeau, ni
     animation pendant la configuration). Mêmes garde-fous : 0 contact avec un bouton, un champ, un texte. */
  function chapeauSeul() { return !C.decor && C.config && C.gabarit === 'product'; }
  function poserChapeaux() {
    if (!TITRES[C.gabarit] || !(C.decor || chapeauSeul())) return;
    var liste = document.querySelectorAll('#main h1');
    for (var i = 0; i < liste.length; i++) {
      var h = liste[i];
      /* 05/10 : `.bksp-h1` = titre des pages PARTENAIRES (lot affiliation) — pas de chapeau sur ce héros sombre,
         où il se lisait comme une tache sur le « D » (photo du lot affiliation, partenaires-1440-01.png). */
      if (h.offsetWidth < 40 || h.closest('.bksaa-hero, .bks-hw-pop, .bksc-band, .bks-404, .bksp-h1')) continue;
      var cs = getComputedStyle(h);
      if (cs.overflowX !== 'visible' || cs.overflowY !== 'visible') return;
      var chap = document.createElement('span');
      chap.className = 'bks-hw-chapeau';
      chap.setAttribute('aria-hidden', 'true');
      chap.setAttribute('data-bks-hw-retirer', '');
      chap.innerHTML = svgUse('bks-hw-s-chapeau', '0 0 64 56');
      if (clair(cs.color)) chap.classList.add('bks-hw-chapeau--nuit');
      h.classList.add('bks-hw-porte-chapeau');
      h.appendChild(chap);
      var o = { h: h, chap: chap };
      chapeaux.push(o);
      placerChapeau(o);
      return;   /* UN chapeau par page : le titre principal */
    }
  }
  function replacer() {
    for (var i = 0; i < chapeaux.length; i++) if (chapeaux[i].chap.parentNode) placerChapeau(chapeaux[i]);
    calerScene();
    calerBandeau();
    var ciel = document.querySelector('.bks-hw-ciel'), hero = ciel && ciel.parentNode;
    if (ciel && hero && !ciel.classList.contains('is-traverse')) calerCielTel(ciel, hero);
  }

  /* 5b. BANDEAU DES COLLECTIONS : balais croisés en filigrane + deux citrouilles (dont une lanterne).
     Tour 1 (vérificateur) : sur les 41 collections publiées AVEC photo (`.bksc-band--img`, dont
     housses-de-selles), balais et citrouilles étaient dessinés SUR la photo (rayures, autocollants) — le lot
     n'avait éprouvé que supermotard, sans photo. Désormais rien n'est posé au jugé : la zone permise est
     mesurée (bandeau sans photo ; avec photo, la colonne de TEXTE seulement, jamais la photo), chaque texte,
     lien, image du bandeau est un obstacle (+ 12 px d'air au bureau, 8 sur téléphone), et l'on cherche la
     place libre la plus proche de l'endroit voulu : 1) balais + 2 citrouilles à leur pied ; sinon 2) balais
     seuls + la citrouille SIMPLE ailleurs (ligne du compteur de produits) ; sinon 3) la citrouille seule ;
     sinon rien. Positions par `translate` (0 décalage de mise en page). */
  function poserBandeau() {
    if (!C.decor || C.gabarit !== 'collection') return;
    var b = document.querySelector('.bksc-band');
    if (!b || b.querySelector('.bks-hw-band')) return;
    var s = document.createElement('span');
    s.className = 'bks-hw-band';
    s.setAttribute('aria-hidden', 'true');
    s.setAttribute('data-bks-hw-retirer', '');
    s.innerHTML = '<span class="bks-hw-band__balais">' + svgUse('bks-hw-s-balai', '0 0 40 100') + svgUse('bks-hw-s-balai', '0 0 40 100') + '</span>';
    s.appendChild(motif('bks-hw-band__citrouille bks-hw-band__citrouille--2', 'bks-hw-s-citrouille', '0 0 64 58'));
    s.appendChild(motif('bks-hw-band__citrouille bks-hw-band__lanterne', 'bks-hw-s-lanterne', '0 0 64 58'));
    b.appendChild(s);
    calerBandeau();
  }
  function obstacles(racine, exclu) {
    var out = [], tw = document.createTreeWalker(racine, NodeFilter.SHOW_TEXT, null), n, k;
    while ((n = tw.nextNode())) {
      if (!/\S/.test(n.nodeValue) || !n.parentElement || exclu.contains(n) || n.parentElement.closest('script,style,template')) continue;
      var r = document.createRange(); r.selectNodeContents(n);
      var l = r.getClientRects(); for (k = 0; k < l.length; k++) if (l[k].width > 0) out.push(l[k]);
    }
    var els = racine.querySelectorAll('img, picture, video, svg, button, a, input, select, textarea, [class*="__media"]');
    for (k = 0; k < els.length; k++) if (!exclu.contains(els[k])) { var q = els[k].getBoundingClientRect(); if (q.width > 0 && q.height > 0) out.push(q); }
    return out;
  }
  function libre(x, y, w, h, ob, m) {
    for (var i = 0; i < ob.length; i++) { var r = ob[i]; if (r.left < x + w + m && r.right > x - m && r.top < y + h + m && r.bottom > y - m) return false; }
    return true;
  }
  /* la place libre (w × h) la plus proche du point voulu (centre px, py), dans la zone Z */
  function chercher(w, h, px, py, Z, ob, m) {
    var best = null, bd = 1e9;
    for (var y = Z.t; y + h <= Z.b; y += 4) for (var x = Z.l; x + w <= Z.r; x += 4) {
      var d = Math.abs(x + w / 2 - px) + 1.5 * Math.abs(y + h / 2 - py);
      if (d >= bd || !libre(x, y, w, h, ob, m)) continue;
      bd = d; best = { x: x, y: y };
    }
    return best;
  }
  function calerBandeau() {
    var s = document.querySelector('.bks-hw-band'); if (!s) return;
    var b = s.parentNode, O = s.getBoundingClientRect(), tel = window.innerWidth < 768;
    var balais = s.querySelector('.bks-hw-band__balais'), lant = s.querySelector('.bks-hw-band__lanterne'), cit = s.querySelector('.bks-hw-band__citrouille--2');
    var tous = [balais, lant, cit];
    for (var i = 0; i < 3; i++) if (tous[i]) tous[i].classList.remove('is-pose');
    if (!balais || !lant || !cit) return;
    var media = b.querySelector('.bksc-band__media'), txt = b.querySelector('.bksc-band__txt');
    var M = media ? media.getBoundingClientRect() : null, m = tel ? 8 : 12, p = tel ? 10 : 14;
    var R = (M && M.width > 0 && txt ? txt : b).getBoundingClientRect();
    var Z = { l: R.left + p, t: R.top + p, r: R.right - p, b: R.bottom - p };
    if (M && M.width > 0) {
      if (M.left > R.left + 40) Z.r = Math.min(Z.r, M.left - p);      /* photo à droite (bureau) */
      else if (M.top > R.top + 20) Z.b = Math.min(Z.b, M.top - p);    /* photo dessous (téléphone) */
    }
    if (Z.r - Z.l < 40 || Z.b - Z.t < 30) return;
    var ob = obstacles(b, s);
    if (M && M.width > 0) ob.push(M);
    /* le point voulu : sans photo, à droite comme avant (7 vw du bord, 40 à 110 px) ; avec photo au bureau,
       au milieu du blanc entre la fin du texte et la photo ; sur téléphone, le coin haut-droit */
    var finTexte = Z.l;
    for (i = 0; i < ob.length; i++) if (ob[i] !== M && ob[i].bottom > Z.t && ob[i].top < Z.b && ob[i].right < Z.r + 1) finTexte = Math.max(finTexte, ob[i].right);
    function voulu(w, h) {
      if (tel) return { x: Z.r - w / 2, y: Z.t + h / 2 };
      if (M && M.width > 0) return { x: (finTexte + Z.r) / 2, y: (Z.t + Z.b) / 2 };
      return { x: R.right - Math.min(110, Math.max(40, window.innerWidth * .07)) - w / 2, y: (R.top + R.bottom) / 2 };
    }
    function poser(el, x, y, w) { el.style.width = Math.round(w) + 'px'; el.style.translate = Math.round(x - O.left) + 'px ' + Math.round(y - O.top) + 'px'; el.classList.add('is-pose'); }
    var TB = tel ? [64, 56, 48] : [120, 104, 88, 72], k, W, q, v;
    /* 1) le groupe : balais W × W, lanterne (0,37 W) centrée à leur pied, petite citrouille (0,23 W) à gauche */
    for (k = 0; k < TB.length; k++) {
      W = TB[k]; var Lw = W * .37, Lh = Lw * 58 / 64, Sw = Math.max(W * .23, 22), Sh = Sw * 58 / 64, H = W * .98 + Lh;
      /* pas de groupe si la lanterne ferait moins de 30 px (balais < 81 px, donc jamais sur téléphone) : au
         rejeu 390, des citrouilles de 15 et 24 px se lisaient comme des points */
      if (Lw < 30) break;
      v = voulu(W, H); q = chercher(W, H, v.x, v.y, Z, ob, m);
      if (!q) continue;
      poser(balais, q.x, q.y, W);
      poser(lant, q.x + W * .52 - Lw / 2, q.y + W * .98, Lw);
      poser(cit, q.x + W * .35 - Sw, q.y + W * .98 + Lh - Sh, Sw);
      return;
    }
    /* 2) les balais seuls, puis 3) la citrouille simple : sur la ligne du compteur (« 61 produits ») si
       elle existe, à droite ; sinon au coin bas-droit de la zone */
    for (k = 0; k < TB.length; k++) {
      W = TB[k]; v = voulu(W, W); q = chercher(W, W, v.x, v.y, Z, ob, m);
      if (q) { poser(balais, q.x, q.y, W); ob.push({ left: q.x, top: q.y, right: q.x + W, bottom: q.y + W }); break; }
    }
    var meta = b.querySelector('.bksc-band__meta'), MR = meta ? meta.getBoundingClientRect() : null;
    var cy = MR && MR.height > 0 ? (MR.top + MR.bottom) / 2 : Z.b - 16, TC = tel ? [28, 24] : [34, 28];
    for (k = 0; k < TC.length; k++) {
      var cw = TC[k], ch = cw * 58 / 64;
      q = chercher(cw, ch, Z.r - cw / 2, cy, Z, ob, m);
      if (q) { poser(cit, q.x, q.y, cw); return; }
    }
  }

  /* 5c. LA 404 : la scène de nuit derrière la carte */
  function poserScene404() {
    if (!C.decor || C.gabarit !== '404') return;
    var sec = document.querySelector('.shopify-section--404 > .section-spacing');
    if (!sec || sec.querySelector('.bks-hw-scene')) return;
    var s = document.createElement('div');
    s.className = 'bks-hw-scene';
    s.setAttribute('aria-hidden', 'true');
    s.setAttribute('data-bks-hw-retirer', '');
    var vol = function (c) { return '<span class="bks-hw-vol ' + c + '">' + svgUse('bks-hw-s-cs', '0 0 64 26', 'bks-hw-cs') + '</span>'; };
    s.innerHTML = '<span class="bks-hw-scene__etoiles"></span><span class="bks-hw-scene__sol"></span><span class="bks-hw-scene__lune"></span>' +
      vol('bks-hw-scene__vol1') + vol('bks-hw-scene__vol2') +
      '<span class="bks-hw-vol bks-hw-scene__sorciere bks-hw-sorciere-nuit">' + svgUse('bks-hw-s-sorciere', '0 0 120 60') + '</span>';
    s.appendChild(motif('bks-hw-scene__c1', 'bks-hw-s-lanterne', '0 0 64 58'));
    s.appendChild(motif('bks-hw-scene__c2', 'bks-hw-s-citrouille', '0 0 64 58'));
    s.appendChild(motif('bks-hw-scene__c3', 'bks-hw-s-citrouille', '0 0 64 58'));
    s.appendChild(motif('bks-hw-scene__chapeau', 'bks-hw-s-chapeau', '0 0 64 56'));
    sec.insertBefore(s, sec.firstChild);
    calerScene();
  }
  /* le ciel s'arrête sous la carte : la section contient aussi la passerelle « Ce n'est pas la bonne porte ? »
     (son propre panneau sombre), qu'on ne recouvre pas */
  function calerScene() {
    var s = document.querySelector('.bks-hw-scene'); if (!s) return;
    var sec = s.parentNode, carte = sec.querySelector('.bks-404'); if (!carte) return;
    var bas = carte.getBoundingClientRect().bottom - sec.getBoundingClientRect().top + (window.innerWidth < 768 ? 26 : 40);
    s.style.bottom = 'auto';
    s.style.height = Math.round(bas - parseFloat(getComputedStyle(s).top || 0)) + 'px';
  }

  /* 5d. PANIER VIDE : une citrouille posée sur le bord de la carte.
     Tour 1 (vérificateur, panier vide 1440) : elle était ancrée sur `.empty-state` (352 → 1088 px), plus large
     que la CARTE grise visible (son `.prose`, 433 → 1007 px) : elle flottait 9 px à droite de la carte, dans
     le blanc. Elle est désormais ancrée sur la carte VISIBLE : le premier élément de l'état vide (lui compris)
     qui a un fond et un arrondi, sans rognage (overflow visible) — sinon l'état vide, comme avant. */
  function carteVisible(e) {
    var l = [e].concat(Array.prototype.slice.call(e.querySelectorAll('*')));
    for (var i = 0; i < l.length && i < 40; i++) {
      var cs = getComputedStyle(l[i]), fond = cs.backgroundImage !== 'none' || !/^(transparent|rgba\(\d+, \d+, \d+, 0\))$/.test(cs.backgroundColor);
      if (fond && parseFloat(cs.borderTopRightRadius) > 0 && cs.overflow === 'visible' && l[i].getBoundingClientRect().width > 200) return l[i];
    }
    return e;
  }
  function poserPanier() {
    if (!C.decor || C.gabarit !== 'cart') return;
    var e = document.querySelector('.shopify-section--main-cart .empty-state');
    if (!e || e.querySelector('.bks-hw-panier')) return;
    var hote = carteVisible(e);
    hote.classList.add('bks-hw-porte-citrouille');
    hote.appendChild(motif('bks-hw-panier', 'bks-hw-s-citrouille', '0 0 64 58'));
  }

  /* 5e. (02/10) LE MÉGA-MENU DU BUREAU. Le tiroir du menu (téléphone) a depuis le 01/10 le croissant et la sorcière
     du pied ; le méga-menu du bureau n'avait rien. On les pose dans son bandeau violet d'appel (« Crée ta selle
     FUSION », `.bkscustom`, fichier du lot menu, habillé, jamais réécrit), dans le blanc entre la fin du TEXTE et
     les boutons — mesuré, pas supposé : 7 panneaux, des sous-titres de longueurs différentes, 1 ou 2 boutons. Pas
     assez d'air (96 px de motif + 48 px de chaque côté), boutons passés à la ligne ou écran < 1024 px → rien.
     Les panneaux arrivent APRÈS le chargement (fetch du lot menu, événement `bks:menu-charge`) et sont cachés
     tant qu'on ne survole pas l'entrée : on mesure quand ils deviennent visibles (ResizeObserver 0 → taille). */
  var MM_W = 96, MM_AIR = 48, megaVus = [], megaRo = null;
  function calerMega(band) {
    var txt = band.firstElementChild, act = band.querySelector('.bksact');
    band.classList.remove('bks-hw-mm');
    if (!txt || !act || window.innerWidth < 1024) return;
    var B = band.getBoundingClientRect(), A = act.getBoundingClientRect();
    if (!B.width || !A.width) return;
    var fin = 0, tw = document.createTreeWalker(txt, NodeFilter.SHOW_TEXT, null), n;
    while ((n = tw.nextNode())) {
      if (!/\S/.test(n.nodeValue)) continue;
      var r = document.createRange(); r.selectNodeContents(n);
      var l = r.getClientRects(); for (var k = 0; k < l.length; k++) if (l[k].width > 0 && l[k].right > fin) fin = l[k].right;
    }
    var T = txt.getBoundingClientRect();
    if (!fin || A.top >= T.bottom - 4 || A.left - fin < MM_W + 2 * MM_AIR) return;   /* boutons à la ligne, ou trop serré */
    band.style.setProperty('--bks-hw-mm-x', Math.round(fin + (A.left - fin - MM_W) / 2 - B.left) + 'px');
    band.classList.add('bks-hw-mm');
  }
  function poserMega() {
    if (!window.ResizeObserver) return;
    megaRo = megaRo || new ResizeObserver(function (l) { for (var i = 0; i < l.length; i++) if (l[i].contentRect.width > 0) { try { calerMega(l[i].target); } catch (e) {} } });
    var b = document.querySelectorAll('.bksmega .bkscustom');
    for (var i = 0; i < b.length; i++) if (megaVus.indexOf(b[i]) < 0) { megaVus.push(b[i]); megaRo.observe(b[i]); }
  }

  function poserMotifs() {
    var decor = html.classList.contains('bks-hw-decor');
    if (!decor && !chapeauSeul()) return;
    if (decor) {
      try { poserBandeau(); } catch (e) {}
      try { poserScene404(); } catch (e) {}
      try { poserPanier(); } catch (e) {}
      try { poserMega(); document.addEventListener('bks:menu-charge', function () { try { poserMega(); } catch (e) {} }); } catch (e) {}
    } else html.classList.add('bks-hw-chap');   /* fiche de configurateur : le chapeau du titre, rien d'autre */
    try { poserChapeaux(); } catch (e) {}
    /* la police du titre arrive après le premier rendu : on remesure quand elle est là, puis à chaque
       changement de taille (rotation du téléphone, fenêtre redimensionnée) */
    try { if (document.fonts && document.fonts.ready) document.fonts.ready.then(replacer); } catch (e) {}
    var att = null;
    window.addEventListener('resize', function () { clearTimeout(att); att = setTimeout(replacer, 150); }, { passive: true });
    window.addEventListener('load', replacer);
  }

  /* ------------------------------------------------------------------ démarrage */
  /* 05/10 (vérificateur technique, tour 1) — DÉMARRAGE EN TROIS TEMPS. Ce fichier était chargé en `defer` : il passait
     13e sur 19 à 22 scripts différés (jQuery sur cdnjs, applis…) et, sur une page lente, ne tournait qu'au bout de
     plusieurs secondes — plus de 60 s mesurées — alors que la capture des fiches et le compte à rebours étaient déjà à
     l'écran (clic → formulaire envoyé par le navigateur, chiffres figés). Il est désormais `async` :
       1. TOUT DE SUITE (à son exécution, souvent pendant l'analyse de la page) : écouteurs (posés plus haut), minuteur
          des comptes à rebours (il relaie celui du script en ligne du snippet), boutons des captures déjà lues activés ;
       2. DÈS QUE LE DOCUMENT EST LU (readyState ≠ « loading », AVANT les scripts différés des autres) : captures des
          fiches dans leur état (inscrit → son code), boutons activés, veille du changement de variante ;
       3. à DOMContentLoaded, COMME AVANT (feuilles de style chargées, mesures justes) : ciel, chapeaux, motifs, pop-up
          automatique — rien de ce qui MESURE la page ne change de moment. */
  var tot = false, tard = false;
  function demarrerTot() {
    if (tot || eteinte) return;
    tot = true;
    if (!enCours()) { eteindre(); return; }
    /* le code, seulement pour qui a le droit (publicité, inscrit) ; les captures des fiches dans leur état */
    try { initCaptures(); } catch (e) {}
    /* une capture re-rendue par Prestige (changement de variante) renaît vide : on la remet dans son état */
    try {
      var zones = document.querySelectorAll('product-rerender');
      if (zones.length && window.MutationObserver) {
        /* seuls les ÉLÉMENTS ajoutés qui sont (ou contiennent) une capture comptent : les chiffres du compte à rebours
           (nœuds texte) changent chaque seconde et ne doivent rien déclencher */
        var att = null, moCap = new MutationObserver(function (l) {
          for (var a = 0; a < l.length; a++) for (var b = 0; b < l[a].addedNodes.length; b++) {
            var n = l[a].addedNodes[b];
            if (n.nodeType === 1 && (n.hasAttribute('data-bks-cap') || n.querySelector('[data-bks-cap]'))) {
              clearTimeout(att); att = setTimeout(function () { try { initCaptures(); } catch (e) {} }, 30); return;
            }
          }
        });
        for (var z = 0; z < zones.length; z++) moCap.observe(zones[z], { childList: true, subtree: true });
      }
    } catch (e) {}
  }
  function demarrerTard() {
    if (tard || eteinte) return;
    tard = true;
    demarrerTot();
    if (eteinte) return;
    /* les délais de la pop-up comptent, comme avant, à partir d'ici (le script différé tournait juste avant
       DOMContentLoaded) : même rythme que celui vérifié le 02/10 */
    T0 = Date.now();
    if (C.config) dernierGeste = Math.max(dernierGeste, T0);
    poserCiel();
    poserMotifs();
    if (popDesiree()) {
      lancerSonde();
      window.addEventListener('cf_consent', function () { bandeauVu = true; if (C.config) dernierGeste = Date.now(); setTimeout(sonder, 150); });
    }
  }
  /* 1. tout de suite */
  if (!enCours()) eteindre();
  else {
    majChronos();
    tic = setInterval(majChronos, 1000);
    if (C.arreterTic) C.arreterTic();   /* le minuteur en ligne du snippet passe la main */
    try { var l0 = document.querySelectorAll('[data-bks-cap]'); for (var i0 = 0; i0 < l0.length; i0++) armer(l0[i0]); } catch (e) {}
  }
  /* 2. dès que le document est lu */
  if (document.readyState === 'loading') {
    document.addEventListener('readystatechange', function lu() {
      if (document.readyState === 'loading') return;
      document.removeEventListener('readystatechange', lu);
      demarrerTot();
    });
  } else demarrerTot();
  /* 3. à DOMContentLoaded. Un script async peut tourner APRÈS lui, et readyState reste « interactive » jusqu'au load :
     on le sait par la mesure de navigation ; filet : l'événement load. */
  function dclPasse() {
    if (document.readyState === 'complete') return true;
    try { var n = performance.getEntriesByType('navigation')[0]; if (n && n.domContentLoadedEventStart > 0) return true; } catch (e) {}
    try { if (performance.timing && performance.timing.domContentLoadedEventStart > 0) return true; } catch (e) {}
    return false;
  }
  if (dclPasse()) demarrerTard();
  else { document.addEventListener('DOMContentLoaded', demarrerTard); window.addEventListener('load', demarrerTard); }
  window.addEventListener('pagehide', function () {
    if (ouvertureId) { clearTimeout(ouvertureId); ouvertureId = null; }
    arreterSonde();
    if (gardienId) { clearInterval(gardienId); gardienId = null; }
  });
})();
